module.exports = __webpack_public_path__ + "img/tela-de-apresentacao.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tela-de-apresentacao.png
// module id = 302
// module chunks = 0